import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix default icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png",
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
});

export const driverIcon = L.divIcon({
  className: "",
  html: '<div class="driver-marker">🚖</div>',
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});

export const passengerIcon = L.divIcon({
  className: "",
  html: '<div class="passenger-marker"></div>',
  iconSize: [28, 28],
  iconAnchor: [14, 14],
});

export const pickupIcon = L.divIcon({
  className: "",
  html: '<div style="background:#10B981;width:24px;height:24px;border-radius:999px;border:3px solid white;box-shadow:0 2px 8px rgba(0,0,0,0.2);"></div>',
  iconSize: [24, 24], iconAnchor: [12, 12],
});

export const destIcon = L.divIcon({
  className: "",
  html: '<div style="background:#EF4444;width:24px;height:24px;border-radius:999px;border:3px solid white;box-shadow:0 2px 8px rgba(0,0,0,0.2);"></div>',
  iconSize: [24, 24], iconAnchor: [12, 12],
});

function Recenter({ center }) {
  const map = useMap();
  useEffect(() => {
    if (center && Array.isArray(center)) {
      map.setView(center, map.getZoom());
    }
  }, [center, map]);
  return null;
}

export default function MapView({ center = [40.4168, -3.7038], zoom = 13, markers = [], recenter = false, children }) {
  return (
    <MapContainer
      center={center}
      zoom={zoom}
      style={{ width: "100%", height: "100%" }}
      zoomControl={false}
      attributionControl={true}
    >
      <TileLayer
        attribution='&copy; OpenStreetMap, &copy; CartoDB'
        url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
      />
      {recenter && <Recenter center={center} />}
      {markers.map((m, i) => (
        <Marker key={m.id || i} position={[m.lat, m.lng]} icon={m.icon || driverIcon}>
          {m.popup && <Popup>{m.popup}</Popup>}
        </Marker>
      ))}
      {children}
    </MapContainer>
  );
}
